import { takeEvery, put } from 'redux-saga/effects';
import {
  AIPPortletsAction,
  AIPPortletsActions,
  AIPPortletsActionTypes,
} from '../../actions/cbo/AIPPortletsAction';
import { AIPPortletsModel, IAIPDataPayload, IConfigValidateRequest, IConfigValidateResponse } from '../../../models/cbo/AIPPortletsModel';
import AIPPortletsService from '../../../services/cbo/AIPPortletsService/AIPPortletsService';
import { AIPProjectReportModel, AIPReportActivitiesModel } from '../../../models/cbo/AIPDashboardReportModel';

export function* getAIPWorker(action: AIPPortletsAction) {
  try {
    const data = action.data as IAIPDataPayload;
    const response: AIPPortletsModel[] = yield AIPPortletsService.getAIPData(data);
    yield put(AIPPortletsActions.getAIPSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIPPortletsActions.getAIPError(error));
    }
  }
}

export function* getAIPProjectStatus() {
  try {
    const response: AIPProjectReportModel[] = yield AIPPortletsService.getAIPProjectsStatus();
    yield put(AIPPortletsActions.getAIPProjectStatusSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIPPortletsActions.getAIPProjectStatusError(error));
    }
  }
}

export function* getAIPProjectActivitiesStatus(action: AIPPortletsAction) {
  try {
    const id = action.data as string;
    const response: AIPReportActivitiesModel[] = yield AIPPortletsService.getAIPProjectsActivities(id);
    yield put(AIPPortletsActions.getAIPProjectActivitiesSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIPPortletsActions.getAIPProjectActivitiesError(error));
    }
  }
}

export function* getConfigValidated(action: AIPPortletsAction) {
  try {
    const body = action.data as IConfigValidateRequest;
    const response: IConfigValidateResponse = yield AIPPortletsService.getValidateConfiguration(body);
    yield put(AIPPortletsActions.getConfigValidateSuccess(response));
  } catch (error) {
    if (error instanceof Error) {
      yield put(AIPPortletsActions.getConfigValidateError(error));
    }
  }
}

export function* aipPortletsWatcher() {
  yield takeEvery(AIPPortletsActionTypes.GET_AIP_STARTED, getAIPWorker);
  yield takeEvery(AIPPortletsActionTypes.GET_AIP_PROJECTS_STATUS_STARTED, getAIPProjectStatus);
  yield takeEvery(AIPPortletsActionTypes.GET_AIP_PROJECTS_ACTIVITIES_STARTED, getAIPProjectActivitiesStatus);
  yield takeEvery(AIPPortletsActionTypes.GET_CONFIG_VALIDATE_STARTED, getConfigValidated);
}
